import { graphqlClient } from '@/lib/graphql-client';
import { buildGetSurveyFormsQuery } from '../graphql/queries';
import {
  DELETE_SURVEY_FORM_MUTATION,
  INSERT_SURVEY_FORM_MUTATION,
  UPDATE_SURVEY_FORM_MUTATION,
} from '../graphql/mutations';
import {
  GetSurveyFormsParams,
  SurveyFormInsertInput,
  SurveyFormsPagingResult,
  SurveyFormUpdateInput,
} from '../types/survey-form.types';

export const getSurveyForms = async (
  params: GetSurveyFormsParams
): Promise<{ SurveyForms: SurveyFormsPagingResult }> => {
  const { pageNo, pageSize, filter = {}, order } = params;
  return graphqlClient.query({
    query: buildGetSurveyFormsQuery(filter, pageNo, pageSize, order),
  });
};

export const getSurveyFormById = async (
  itemId: string
): Promise<{ SurveyForms: SurveyFormsPagingResult }> =>
  graphqlClient.query({
    query: buildGetSurveyFormsQuery({ ItemId: itemId }, 1, 1),
  });

export const createSurveyForm = async (input: SurveyFormInsertInput) => {
  return graphqlClient.mutate({ query: INSERT_SURVEY_FORM_MUTATION, variables: { input } });
};

export const updateSurveyForm = async (params: {
  itemId: string;
  input: SurveyFormUpdateInput;
}) => {
  const filter = JSON.stringify({ _id: params.itemId });
  return graphqlClient.mutate({
    query: UPDATE_SURVEY_FORM_MUTATION,
    variables: { filter, input: params.input },
  });
};

export const deleteSurveyForm = async (itemId: string) => {
  const filter = JSON.stringify({ _id: itemId });
  return graphqlClient.mutate({
    query: DELETE_SURVEY_FORM_MUTATION,
    variables: { filter, input: { isHardDelete: false } },
  });
};
